import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Rating from "@mui/material/Rating";
import Slider from "@mui/material/Slider";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import ThumbDownAltTwoToneIcon from "@mui/icons-material/ThumbDownTwoTone";
import ThumbUpAltTwoToneIcon from '@mui/icons-material/ThumbUpAltTwoTone';
import "./style.scss";

const StyledRating = styled(Rating)(({ theme }) => ({}));

const emojiIcons = {
  1: {
    icon: <SentimentDissatisfiedIcon color="inherit" />,
    label: "Dissatisfied",
  },
  2: {
    icon: <SentimentSatisfiedIcon color="inherit" />,
    label: "Neutral",
  },
  3: {
    icon: <SentimentSatisfiedAltIcon color="inherit" />,
    label: "Satisfied",
  },
};

const thumbsIcon = {
  1: {
    icon: <ThumbUpAltTwoToneIcon className="thumbsUp" color="inherit" />,
    label: "Satisfied",
  },
  2: {
    icon: <ThumbDownAltTwoToneIcon className="thumbsDown" color="inherit" />,
    label: "Dissatisfied",
  },
};

export const marks = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 20,
    label: "20",
  },
  {
    value: 40,
    label: "40",
  },
  {
    value: 60,
    label: "60",
  },
  {
    value: 80,
    label: "80",
  },
  {
    value: 100,
    label: "100",
  },
];

const IconContainer: React.FC<any> = (props) => {
  const { value, type, ...other } = props;
  const iconSet: any = type === "emoji" ? emojiIcons : thumbsIcon;
  return <span {...other}>{iconSet[value].icon}</span>;
}

IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
};

type EmojiRatingProps = {
  ratingValue: any
}

const EmojiRating: React.FC<EmojiRatingProps> = ({ ratingValue }) => {
  const iconType = ratingValue?.ratingSettings?.ratingType;
  return (
    <>
      {
        ["emoji", "thumbs"].includes(iconType) ?
          <StyledRating
            name="highlight-selected-only"
            className="styled-rating"
            max={iconType === "emoji" ? 3 : 2}
            IconContainerComponent={(props) =>
              IconContainer({ ...props, type: iconType })
            }
            highlightSelectedOnly
          />
          : iconType === "slider" ? (
            <Slider
              className="Slider-Rating-container"
              defaultValue={0}
              step={10}
              valueLabelDisplay="auto"
              marks={marks}
            />
          ) : (
            <></>
          )}
    </>
  );
};

export default EmojiRating;
